import React, { useEffect, useState } from "react";
import { IoIosAddCircle } from "react-icons/io";
import axios from "../../../lib/axios";
import { Link } from "react-router-dom";
import Delete from "../../../components/Delete";
import { useDispatch, useSelector } from "react-redux";
import { AiOutlineLoading3Quarters } from "react-icons/ai";
import { IoMdAdd } from "react-icons/io";
import { FaEdit } from "react-icons/fa";
import { MdDelete } from "react-icons/md";
import { setDelete } from "../../../redux/features/deleteSlice";
import toast from "react-hot-toast";
import { toEn } from "../../../lib/toEn";

function EmployeeList() {
  const [employees, setEmployees] = useState([]);
  const deleteItem = useSelector((state) => state.delete.item);
  const inputs = {
    name: "",
    address: "",
    phone_number: "",
    salary: "",
    detail: "",
  };
  const [employee, setEmployee] = useState(inputs);
  const [id, setId] = useState(null);
  const [loading, setLoading] = useState(false);

  const dispatch = useDispatch();

  useEffect(() => {
    if (!deleteItem.id) {
      getEmployees();
    }
  }, [deleteItem]);

  const getEmployees = () => {
    axios
      .get("/api/settings/employees")
      .then((data) => {
        setEmployees(data);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const updateEmployee = (index, value) => {
    setEmployee((prevValue) => ({ ...prevValue, [index]: value }));
  };

  const handleItemChange = (index, e) => {
    const value = toEn(e);
    const regex = /^[0-9]*(\.[0-9]{0,3})?$/;
    console.log(value);
    if (regex.test(value)) {
      updateEmployee(index, value);
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setLoading(true);
    console.log("teaam", employee);
    axios
      .post("/api/settings/employee/create", { id, ...employee })
      .then((data) => {
        console.log("dooooo", id);
        if (id) {
          setEmployees((prevEmployees) =>
            prevEmployees.map((row) => {
              if (row.id === id) {
                return data;
              }
              return row;
            })
          );
        } else {
          setEmployees([data, ...employees]);
        }
        setLoading(false);
        toast.success("موفقانه ثبت گردید.");
        setEmployee(inputs);
        setId(null);
      })
      .catch((error) => {
        setLoading(false);
        const message = error?.response?.data?.message;
        toast.error(message ? message : error.message);
        console.log(error);
      });
  };

  return (
    <div>
      <div className="flex bg-slate-50 border justify-between py-2 px-4">
        <h3>کارمندان</h3>
      </div>
      <div className="p-4 flex flex-row gap-6">
        <div className="w-2/3">
          <table className="table-auto w-full overflow-y-auto">
            <thead>
              <tr>
                <th className="px-4 py-2 text-start">#</th>
                <th className="px-4 py-2 text-start">نام</th>
                <th className="px-4 py-2 text-start">نمبر تماست </th>
                <th className="px-4 py-2 text-start">مقدار معاش</th>
                <th className="px-4 py-2 text-start">آدرس</th>
                <th className="px-4 py-2 text-start">عملیه ها</th>
              </tr>
            </thead>
            <tbody>
              {employees.map((row, index) => (
                <tr
                  key={index}
                  className={`${
                    index % 2 === 0 ? "bg-gray-100" : "bg-white"
                  } border`}
                >
                  <td className="px-4 py-2">{row.id}</td>
                  <td className="px-4 py-2">{row.name}</td>
                  <td className="px-4 py-2">{row.phone_number}</td>
                  <td className="px-4 py-2">{row.salary}</td>
                  <td className="px-4 py-2">{row.address}</td>
                  <td className="px-4 py-2 flex gap-4">
                    <button
                      onClick={() => {
                        setEmployee({ ...row });
                        setId(row.id);
                      }}
                    >
                      <FaEdit className="text-green-500" />
                    </button>
                    <button
                      onClick={() =>
                        dispatch(
                          setDelete({
                            item: row,
                            url: `/api/settings/employee/${row.id}`,
                          })
                        )
                      }
                    >
                      <MdDelete className="text-red-500" size={20} />
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
          {deleteItem.id && <Delete />}
        </div>

        <form
          action="#"
          method="post"
          onSubmit={handleSubmit}
          className=" w-1/3  rounded-t-md "
        >
          <div className=" bg-gray-100 border px-4 py-2 rounded-t-md">
            فورم ثبت کارمندان
          </div>

          <div className="p-8 border-x ">
            <div className="flex justify-between">
              <label htmlFor="name">
                {" "}
                نام<span className="text-red-500">*</span>
              </label>
              <input
                name="name"
                required
                onChange={(e) => updateEmployee("name", e.target.value)}
                value={employee.name}
                placeholder="علی محمودی"
                className="ring-1 ring-inset ring-gray-300  mb-3 p-2 rounded-md w-2/3"
              />
            </div>

            <div className="flex justify-between">
              <label htmlFor="name">
                {" "}
                نمبر تماس <span className="text-red-500">*</span>
              </label>
              <input
                name="phone_number"
                required
                onChange={(e) => updateEmployee("phone_number", e.target.value)}
                value={employee.phone_number}
                placeholder="07XXXXXXXX"
                className="ring-1 ring-inset ring-gray-300  mb-3 p-2 rounded-md w-2/3"
              />
            </div>
            <div className="flex justify-between">
              <label htmlFor="name">
                {" "}
                مقدار معاش<span className="text-red-500">*</span>
              </label>
              <input
                name="salary"
                type="text"
                required
                onChange={(e) => handleItemChange("salary", e)}
                value={employee.salary}
                placeholder="200.00"
                className="ring-1 ring-inset ring-gray-300  mb-3 p-2 rounded-md w-2/3"
              />
            </div>
            <div className="flex justify-between">
              <label htmlFor="name"> آدرس</label>
              <textarea
                name="address"
                placeholder="آدرس..."
                onChange={(e) => updateEmployee("address", e.target.value)}
                value={employee.address}
                className="ring-1 ring-inset ring-gray-300  mb-3 p-2 rounded-md w-2/3"
              />
            </div>
            <div className="flex justify-between">
              <label htmlFor="name"> بیشتر</label>
              <textarea
                placeholder="بیشتر..."
                name="detail"
                onChange={(e) => updateEmployee("detail", e.target.value)}
                value={employee.detail}
                className="ring-1 ring-inset ring-gray-300  mb-3 p-2 rounded-md w-2/3"
              />
            </div>
          </div>

          <div className="flex justify-end bg-gray-100 px-4 py-2 border">
            <button
              className="flex gap-2 bg-green-500 text-white rounded-sm p-2 hover:bg-green-700"
              type="submit"
              disabled={loading ? true : false}
            >
              {loading ? (
                <AiOutlineLoading3Quarters className="mt-1 animate-spin" />
              ) : (
                <IoMdAdd className="mt-1" />
              )}
              ثبت
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}

export default EmployeeList;
